// frontend/src/modules/appState.js
import { DEFAULT_FILTERS, STEP, UPLOAD_MODE } from './workflowConfig';

export const initialState = {
  file: null,
  deviceFiles: [],
  loading: false,
  tables: [],
  transformedTables: [],
  error: '',
  documentType: '',
  deviceType: '',
  currentStep: STEP.SELECT_TYPE,
  uploadMode: UPLOAD_MODE.FULL,
  selectedSinglePageDirectory: '',
  directoryInfo: [],
  selectedDirectory: '',
  availableTables: [],
  tableHtml: '',
  selectedLevel: DEFAULT_FILTERS.selectedLevel,
  availableLevels: [],
  currentTransformationType: 'original',
  offsetAmount: '1',
  carTablesByLevel: {},
  historyLoading: false,
  historyTasks: [],
  historyTaskContext: null
};